<template>
  <!-- 2カラムページの場合は'is-2column'クラスを付与 -->
  <!-- ヘッダーを隠すの場合は'is-hidden-header'クラスを付与 -->
  <div id="body"
    :class="{'is-hidden-header' : targetScrollFlg}"
    @scroll="handleScroll"
  >
  <BackgroundImage />

    <!-- menu:start -->
    <PCMenu
      class="visible"
      v-if="visibleMenu"
      @closeMenu="visibleMenu = false"
    />
    <!-- menu:end -->

    <!-- Cancel Input Popup -->
    <transition name="popup">
      <PCServiceLicenseCancelCancel
        v-if="state.visibleCancelInput"
        @closeServiceLicenseCancel="state.visibleCancelInput = false"
      />
    </transition>

    <!-- View Confirm Popup -->
    <transition name="popup">
      <PCServiceLicensePurchaseConfirm
        v-if="purchase.visiblePopup === 'confirm'"
        @closeViewConfirm="action.closeConfirm"
        @openViewComplete="action.submitConfirm"
      />
    </transition>

    <!-- View Complete Popup -->
    <transition name="popup">
      <PCServiceLicensePurchaseComplete
        v-if="purchase.visiblePopup === 'complete'"
        @closeViewComplete="action.closeComplete"
      />
    </transition>

    <div id="wrapper">
      <!-- header:start -->
      <header id="header" class="header">
        <PCButtonHistoryBack />
      </header>
      <!-- header:end -->

      <!-- menu-bar:start -->
      <!-- open -->
      <div class="menu-bar" role="button" 
        :class="{'is-open' : !targetScrollFlg}"
        @click="visibleMenu = !visibleMenu"
      >
        <IconMenu class="icn" 
          v-if="!targetScrollFlg"
        />
        <FontawesomeIcon :icon="['far','chevron-up']" size="lg" class="icn"
          v-if="targetScrollFlg"
        />
      </div>
      <!-- close -->
      <!-- menu-bar:end -->

      <!-- content:start -->
      <div id="content"
        style="height:calc(100vh - 16px);"
      >
        <div class="service" id="scroll-target"
          @scroll="handleScroll"
          >
          <div class="service-head">
            <h1 class="hdg02">追加購入</h1>
          </div>
          <form v-if="state.loaded" action="/pc/estimate-confirm" method="post" class="service-container">
            <div class="service-content">
              <div class="service-link-head">
                <router-link to="/pc/service-license-cancel-input" class="txt-blue" target="_blank">パッケージ・ライセンスの解約申し込みはこちら</router-link>
              </div>
              <template v-if="signedNewPackageProduct.length > 0">
                <h2 class="hdg03">契約中パッケージのライセンス追加購入</h2>
                <p class="txt">購入を希望する商品の追加ライセンス数（人数）をご指定ください。</p>
                <ul class="service-content-list">
                  <li class="service-content-list-item">
                    <table class="license-content-table border">
                      <colgroup>
                        <col style="width:20%;">
                        <col sytle="width:40%;">
                        <col sytle="width:20%;">
                        <col sytle="width:15%;">
                        <col sytle="width:5%;">
                      </colgroup>
                      <thead>
                        <tr>
                          <th>パッケージ</th>
                          <th>商品</th>
                          <th></th>
                          <th class="ta-center">ライセンス数を指定</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(product, index) in signedNewPackageProduct" :key="'signedpack_' + index">
                          <th v-if="index === 0 || product.packIndex !== product.prevPackIndex" :rowspan="product.count">
                            <div class="license-content-table-hdg">{{product.package_name}}</div>
                          </th>
                          <td :class="product.classification !== 2 && 'pl20'">
                            <div class="license-content-table-title">{{product.name}}</div>
                            <div class="license-content-table-sup mt12">{{visible.note(index)}}</div>
                          </td>
                          <td>
                            <div class="license-content-table-link">
                              <span v-if="visible.buy(index)" @click="action.buy(index, product.select[0])" role="button">購入</span>
                              <div v-else-if="visible.cancel(index)" @click="action.cancel(index)" role="button">解約予約の取り消し</div>
                            </div>
                          </td>
                          <td>
                            <div v-if="visible.select(index)" class="license-content-table-select">
                              <SelectBox
                                :selected="purchase.lists[index].purchase"
                                :lists="product.select"
                                @change="action.selectBoxOnChange($event, index)"
                                />
                            </div>
                          </td>
                          <td>
                            <div :style="{visibility: visible.reset(index) ? 'visible' : 'hidden'}" @click="action.reset(index)" class="license-content-table-reset" role="button">
                              <div class="license-content-table-reset-tip">リセット</div>
                              <FontawesomeIcon :icon="['far','eraser']" size="lg" class="icn"/>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </li>
                </ul>
              </template>
              
              <template v-if="unsignedNewPackageProduct.length > 0">
                <h2 class="hdg03">未契約パッケージの購入</h2>
                <p class="txt">購入を希望する商品の「購入」ボタンを押下後、ライセンス数（人数）をご指定ください。<br>パッケージによっては、ご購入いただけるライセンス数をあらかじめ設定しているものがございます。</p>
                <ul class="service-content-list">
                  <li class="service-content-list-item">
                    <table class="license-content-table border">
                      <colgroup>
                        <col style="width:20%;">
                        <col sytle="width:40%;">
                        <col sytle="width:20%;">
                        <col sytle="width:15%;">
                        <col sytle="width:5%;">
                      </colgroup>
                      <thead>
                        <tr>
                          <th>パッケージ</th>
                          <th>商品</th>
                          <th></th>
                          <th class="ta-center">ライセンス数を指定</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(product, index) in unsignedNewPackageProduct" :key="'unsignedpack_' + index">
                          <th v-if="index === 0 || product.packIndex !== product.prevPackIndex" :rowspan="product.count">
                            <div class="license-content-table-hdg">{{product.package_name}}</div>
                          </th>
                          <td>
                            <div class="license-content-table-title">{{product.name}}</div>
                            <div class="license-content-table-sup mt12">{{visible.note(signedNewPackageProduct.length + index)}}</div>
                          </td>
                          <td>
                            <div class="license-content-table-link">
                              <span v-if="visible.buy(signedNewPackageProduct.length + index)" @click="action.buy(signedNewPackageProduct.length + index, product.select[0])" role="button">購入</span>
                              <div v-else-if="visible.cancel(signedNewPackageProduct.length + index)" role="button">解約予約の取り消し</div>
                            </div>
                          </td>
                          <td>
                            <div v-if="visible.select(signedNewPackageProduct.length + index)" class="license-content-table-select">
                              <SelectBox
                                :selected="purchase.lists[signedNewPackageProduct.length + index].purchase"
                                :lists="product.select"
                                @change="action.selectBoxOnChange($event, signedNewPackageProduct.length + index)"
                                />
                            </div>
                          </td>
                          <td>
                            <!-- <div v-if="visible.reset(signedNewPackageProduct.length + index)" @click="action.reset(signedNewPackageProduct.length + index)" class="license-content-table-reset" role="button"> -->
                            <div :style="{visibility: visible.reset(signedNewPackageProduct.length + index) ? 'visible' : 'hidden'}" @click="action.reset(signedNewPackageProduct.length + index)" class="license-content-table-reset" role="button">
                              <div class="license-content-table-reset-tip">リセット</div>
                              <FontawesomeIcon :icon="['far','eraser']" size="lg" class="icn"/>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </li>
                </ul>
              </template>

              <template v-if="paymentMethod.paymentMethodID != 0">
                <h2 class="hdg03">お支払い方法</h2>
                <div class="service-content-inner">
                  <p class="txt fw-bold">{{ paymentMethod.paymentMethodName }}</p>
                  <!-- 7: 銀行振込の場合-->
                  <p class="txt-sup" v-if="paymentMethod.paymentMethodID === 7">クレジットカードまたは口座振替をご利用頂く場合、契約情報の「既定のお支払い」の設定を変更してください。</p>
                </div>
              </template>

              <h2 class="hdg03">弊社社員からの紹介</h2>
              <div class="service-content-inner">
                <p class="txt">弊社社員からの紹介であれば社員名を入力してください。</p>
                <div class="formparts text" style="max-width:460px;">
                  <input type="text" placeholder="山田 太郎" v-model="purchase.options.charge_name">
                </div>
                <p class="txt-sup">不明の場合は入力不要です。</p>
              </div>

              <div class="service-submit">
                <div :class="['button', 'service-submit-button', purchaseList.length <= 0 && 'is-inactive']">
                  <span class="btn ga-admin-license-purchase-confirm" @click="action.submit" role="button">確認</span>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <!-- content:end -->
      <span id="btnTop" @click="scrollAreaTop('#scroll-target')">TOP</span>
    </div>
  </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api'
import { ServiceLicensePurchaseInput } from '@/logic/contract/ServiceLicensePurchaseInput'

import PCMenu from '@/components/pc/popup/PCMenu.vue'
import PCServiceLicenseCancelCancel from '@/components/pc/popup/PCServiceLicenseCancelCancel.vue'
import PCServiceLicensePurchaseConfirm from '@/components/pc/popup/PCServiceLicensePurchaseConfirm.vue'
import PCServiceLicensePurchaseComplete from '@/components/pc/popup/PCServiceLicensePurchaseComplete.vue'
import SelectBox from '@/components/pc/partial/SelectBox.vue'

export default defineComponent({
  components: {
    PCMenu,
    PCServiceLicenseCancelCancel,
    PCServiceLicensePurchaseConfirm,
    PCServiceLicensePurchaseComplete,
    SelectBox
  },
  setup (props, context) {
    return { ...ServiceLicensePurchaseInput(context) }
  }
})
</script>

<style lang="scss" scoped>
#content {
  background-color: #fff;
  border-radius: 8px 8px 0 0;
  margin-bottom: 60px;
  overflow-y: auto;
}
.service {
  width: 100%;
  overflow: auto;
  &-container {
    border-top: 1px solid $color-line;
    padding: 40px 0;
    .button .btn[type="submit"] {
      width: 230px;
      margin: 32px auto 0;
    }
  }
  &-head {
    padding: 35px 40px;
    [class^="hdg"] {
      margin-bottom: 0;
    }
  }
  &-content {
    max-width: 1105px;
    padding: 0 40px;
    margin: 0 auto;
    .hdg03{
      margin: 40px 0 29px;
    }
    &-inner{
      border-top: 1px solid $color-line;
      padding: 32px 0;
      &+.hdg03{
        margin-top: 16px;
      }
    }
    &-list {
      list-style: none;
      &-item {
        border-top: 1px solid $color-line;
        padding: 32px 0;
      }
    }
    &-table {
      width: 100%;
      border-collapse: collapse;
      .border-none {
        border: 0!important;
      }
      &.border-bottom {
        border-bottom: 1px solid $color-line;
      }
      thead {
        th {
          color: $color-sup;
          font-size: 1.6rem;
          font-weight: normal;
          padding: 16px 20px;
        }
      }
      tbody {
        th {
          vertical-align: baseline;
        }
        th,td {
          padding: 16px 20px;
          border-top: 1px solid $color-line;
        }
        tr {
          td:last-child {
            padding-right: 40px;
          }
        }
      }
      &-hdg {
        display: block;
        color: $color-hdg;
        font-size: 1.6rem;
        font-weight: bold;
        &.is-inactive {
          color: $color-inactive;
        }
      }
      &-sup {
        color: $color-sup;
        font-size: 1.4rem;
      }
      &-btnarea {
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        position: relative;
        .service-content-table-link {
          position: absolute;
          right: -40px;
          top: 50%;
          transform: translate3d(0,-50%,0);
        }
      }
      &-btn {
        width: 160px;
        .formparts.select .select-label,
        .button .btn {
          height: 32px;
        }
      }
      &-link {
        font-size: 1.6rem;
        color: $color-link;
        padding: 4px;
        border-radius: 4px;
        transition: all .2s;
        position: relative;
        &:hover {
          box-shadow: 0px 3px 6px rgba(0,0,0,.16);
          .service-content-table-link-tip {
            opacity: 1;
          }
        }
        &-tip {
          position: absolute;
          top: -20px;
          left: 50%;
          transform: translate3d(-50%,0,0);
          white-space: nowrap;
          font-size: 1.4rem;
          transition: all .2s;
          opacity: 0;
        }
      }
    }
  }
  &-link-head{
    font-size: 1.8rem;
    padding-bottom: 32px;
  }
  &-submit {
    width: 230px;
    margin: 0 auto;
  }
  .txt + .formparts{
    margin: 20px 0;
  }
  .txt-blue {
    @include hoverOpacity;
  }

}
</style>
